import { combineReducers } from "redux";
import pimadatasReducer from "./pimadataReducer";
import arizonadatasReducer from "./arizonadataReducer";
import authReducer from "./authReducer";
import alertReducer from "./alertReducer";

export default combineReducers({
  pimadata: pimadatasReducer,
  arizonadata: arizonadatasReducer,
  alert: alertReducer,
  auth: authReducer,
});
